import { QuestionAnswer, Node } from '@ispm-client/modules/process-executor/models';

export class ProcessInputDataUtils {

  public static convertQuestionAnswerToJson(questionAnswer: QuestionAnswer) {
    return questionAnswer.answer != null && questionAnswer.answer !== ''
      ? (questionAnswer.answerType === 'number'
        ? JSON.parse(`{"${questionAnswer.question}":${questionAnswer.answer}}`)
        : JSON.parse(`{"${questionAnswer.question}":"${questionAnswer.answer}"}`))
      : JSON.parse(`{"${questionAnswer.question}":null}`);
  }

  public static convertFieldsNamesToEmptyInputData(names: string[]) {
    const answer = { };
    names.forEach(name => answer[name] = null);
    return answer;
  }

  public static convertMultipleQuestionAnswersToJson(questionsAndAnswers: QuestionAnswer[]) {
    const questionAnswersArray =
      questionsAndAnswers.map(questionAnswer => ProcessInputDataUtils.convertQuestionAnswerToJson(questionAnswer));
    let questionAnswersDictionary = null;
    for (const questionAnswer of questionAnswersArray) {
      questionAnswersDictionary = { ...questionAnswersDictionary, ...questionAnswer};
    }
    return questionAnswersDictionary;
  }

  public static collectQuestionsAndAnswersFromNodes(nodes: Node[]) {
    return [].concat(...nodes.map(node => node.questionsAndAnswers));
  }

  public static createProcessInputDataForPath(patientData: any, path: Node[]) {
    const questionsAndAnswers: QuestionAnswer[] = ProcessInputDataUtils.collectQuestionsAndAnswersFromNodes(path);
    const jsonOfExecutedNodes = ProcessInputDataUtils.convertMultipleQuestionAnswersToJson(questionsAndAnswers);
    return Object.assign({ }, patientData, jsonOfExecutedNodes);
  }

  public static createProcessInputData(clickedNodeId: string, patientData: any, executedNodes: Node[]) {
    const clickedNodeIndex = executedNodes.findIndex(node => node.nodeId === clickedNodeId);
    const nodesToCreateDataFrom = executedNodes.slice(0, clickedNodeIndex + 1);
    return this.createProcessInputDataForPath(patientData, nodesToCreateDataFrom);
  }

  public static convertNodeDetailsToQuestionAnswers(nodeDetails: any): QuestionAnswer[] {
    if (nodeDetails) {
      let details = [].concat(...[nodeDetails.fields, nodeDetails.questions]);
      details = details.filter(detail => detail !== null && detail !== undefined);
      return details.map(detail => ProcessInputDataUtils.convertNodeDetailToQuestionAnswer(detail.$type, detail.type, detail.key, detail.value));
    }
  }

  private static convertNodeDetailToQuestionAnswer($type: string, type: string, key: string, value: string = null) {
    return new QuestionAnswer(key, value, type);
  }
}
